import { AIResultDisplayModel, AIResultViewModel } from './AIResultMapper'
import { AIFeature, AIFeaturePreset, RoomSession } from '@zocks-communications/client-sdk-js'
import React, { ComponentType } from 'react'

export enum AIExecutionType {
  NORMAL = 'normal',
  RERUN = 'rerun',
  ON_DEMAND = 'on-demand',
  DYNAMIC = 'dynamic',
}

export interface ActionableAIResultProps {
  aiFeature: AIFeature
  aiResult: AIResultViewModel
  aiResultDisplay: AIResultDisplayModel
  onDismissAIResult?: (aiResultDisplay: AIResultDisplayModel) => void
  totalSegmentations?: number | null
  onAIResultChanged?: (changedResult: string, changedAIResultDisplayId: string) => Promise<void>
  executionType?: AIExecutionType
  onSelectAIResult?: (aiResult: AIResultDisplayModel) => void
  onSelectTaskAIResult?: (checked: boolean, aiResult: AIResultDisplayModel) => void
}

export interface ActionableAIFeatureProps {
  aiFeature: AIFeature
  aiFeaturePreset?: AIFeaturePreset
  aiResults: AIResultViewModel[]
  aiResultsLoading: boolean
  ActionableAIResultElement: ComponentType<ActionableAIResultProps>
  onDismissAIResult: (aiResult: AIResultDisplayModel) => void
  onRerunAIFeature: (aiExecuteInput: AIExecuteInput) => void
  showScoreAIResult?: boolean
  resultBlockOpened?: boolean
  showAIResultEdit?: boolean
  executionType?: AIExecutionType
  onSelectAIResult: (aiResult: AIResultDisplayModel) => void
}

export interface FinancialAdvisorSummaryProps {
  roomId?: string
  sessionId?: string
}

export interface AIExecuteInput {
  aiFeature: AIFeature
  context: object
}

export type DemoSessionContext = {
  demoModeEnabled: boolean
}

export const RoomSessionContext = React.createContext<RoomSession | null>(null)
export const DemoSessionContext = React.createContext<DemoSessionContext>({ demoModeEnabled: false })

export const StreamingEventType: Record<string, string> = {
  MESSAGE_START: 'message_start',
  PRE_JSON_TEXT_DELTA: 'pre_json_text_delta',
  TEXT_DELTA: 'text_delta',
  TOOL_USE_START: 'tool_use_start',
  TOOL_USE_STOP: 'tool_use_stop',
  MESSAGE_STOP: 'message_stop',
  ERROR: 'error',
} as const
